import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_2 = { class: "sm:w-6/12 w-full" }
const _hoisted_3 = { class: "whitespace-pre-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseInfo = _resolveComponent("BaseInfo")!

  return (_ctx.infoMessages)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoMessages, (infoMessage) => {
            return (_openBlock(), _createBlock(_component_BaseInfo, {
              key: infoMessage,
              class: "m-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("pre", _hoisted_3, _toDisplayString(infoMessage), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}